import React from "react"
import { NavLink } from "react-router-dom"

function RcmpLink(props) {
    const { to, children, activeClassName, ...oRest } = props;

    if (to && to?.substring(0, 2) === "./")
        return (
            <a href={to.slice(1)} {...oRest}>
                {children}
            </a>
        )

    return (
        <NavLink to={to} activeClassName={activeClassName} {...oRest}>
            {children}
        </NavLink>
    );
}

export default RcmpLink;